// src/utils/passageAttempt.js
//
// Shared "did the candidate attempt this passage?" helpers for the expert
// evaluation screens (FetchPassageById, finalPassageTextlog, StudentAssignmentReport).
//
// A candidate who submits nothing for a passage used to make comparePassages bail
// out early, which left the PREVIOUS passage's diff, mistake lists and marks on
// screen attributed to the unattempted one. The passage must still be diffed so the
// expert can see the whole model answer was missed - it just has to score zero.

// A passage counts as unattempted when the student's text is null, empty, or whitespace.
export const hasText = (value) => value != null && String(value).trim() !== '';

// The compare service needs something to diff against. A single space tokenises to
// nothing, so every model-answer word comes back as an omission - the same substitution
// the official bulk pipeline uses (services/comparisonService.js buildComparisonItems
// and shorthand-backend/services/marksCalculation.js).
export const BLANK_PASSAGE = ' ';

export const forCompare = (value) => (hasText(value) ? value : BLANK_PASSAGE);

// Every category the compare service returns, empty. Used to clear the panels rather
// than leaving stale results behind.
export const EMPTY_MISTAKES = { spelling: [], missed: [], added: [], grammar: [] };
